const customizePage = []

export default {
  configPage: {},

  customizePage: customizePage.flat()
};
